const host = process.env.BACKEND_URL || "https://api.trainvalleydev.com";
export function bundlesUrl() {
    return `${host}/v1/bundles`;
}
export function bundleUrl(id) {
    return `${bundlesUrl()}/${id}`;
}
export function modelsUrl() {
    return `${host}/v1/models`;
}
export function lastBuildRequestUrl() {
    return `${host}/v1/build_requests/last`;
}
export function newBuildRequestUrl() {
    return `${host}/v1/build_requests/new`;
}
export function rebuildAllBundlesUrl() {
    return `${host}/v1/build_requests/new?target=all`;
}
export function lastBundleLogUrl() {
    return `${host}/v1/build_requests/log`;
}
export function propsUrl() {
    return `${host}/v1/props`;
}
export function materialsUrl() {
    return `${host}/v1/materials`;
}
export function materialUrl(id) {
    return `${host}/v1/materials/${id}`;
}
export function shadersUrl() {
    return `${host}/v1/shaders`;
}
export function localCatalogUrl() {
    return `${host}/v1/bundles/localCatalog.json`;
}
export function resourcesUrl() {
    return `${host}/v1/resources`;
}
export function resourceUrl(id) {
    return `${host}/v1/resources/${id}`;
}
export function locomotivesUrl() {
    return `${host}/v1/locomotives`;
}
export function locomotiveUrl(id) {
    return `${host}/v1/locomotives/${id}`;
}
export function railcarsUrl() {
    return `${host}/v1/railcars`;
}
export function railcarUrl(id) {
    return `${host}/v1/railcars/${id}`;
}
export function texturesUrl() {
    return `${host}/v1/textures/`;
}
export function levelsUrl() {
    return `${host}/v1/levels`;
}
export function levelUrl(id) {
    return `${host}/v1/levels/${id}`;
}
export function binaryDataUrl(id) {
    return `${host}/v1/binary_data/${id}/data`;
}
export function binaryMetadataUrl(id) {
    return `${host}/v1/binary_data/${id}/metadata`;
}
export function buildingStepLogUrl(id) {
    return `${host}/v1/build_requests/step/${id}/log`;
}
export function propSoundsUrl(id) {
    return `${host}/v1/sounds/props/${id}`;
}
export function locomotiveSoundsUrl(id) {
    return `${host}/v1/sounds/locomotives/${id}`;
}
export function modelsArchiveDownloadUrl() {
    return `${host}/v1/models/download`;
}
export function gameBuildsUrl() {
    return `${host}/v1/game_builds`;
}
export function gameBuildUrl(uuid) {
    return `${host}/v1/download_builds/${uuid}`;
}
export function perksUrl() {
    return `${host}/v1/perks`;
}
export function productionsUrl() {
    return `${host}/v1/productions`;
}
